"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CollapsibleCharacteristic = _interopRequireDefault(require("./CollapsibleCharacteristic"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const EntelPlanCardBodyWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 0px;
`;
const EntelPlanCardBody = _ref => {
  let {
    characteristics,
    planIndex
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(EntelPlanCardBodyWrapper, {
    "data-testid": "plan-characteristics"
  }, characteristics.map((characteristic, index) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_CollapsibleCharacteristic.default, _extends({
      planIndex: planIndex
    }, characteristic)), index !== characteristics.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
      noMargin: true,
      appearance: "secondary"
    }));
  }));
};
var _default = EntelPlanCardBody;
exports.default = _default;